import { SinisterStage } from "./stageOptions";

// Prazo (em dias corridos) de cada etapa da cobrança. O backend grava a data do prazo na mudança de etapa
// (data da mudança + dias da etapa); estes valores só servem de reserva quando a API não devolve o total.
export const DEADLINE_DAYS_BY_STAGE: Partial<Record<SinisterStage, number>> = {
	pre_sinister: 20,
	post_sinister: 30,
};

export const DEFAULT_DEADLINE_DAYS = 20;

// Etapas em que a contagem do prazo depende da etapa (e não do status "Em atuação").
export const STAGE_COUNTDOWN_STAGES: SinisterStage[] = ["post_sinister"];

export const getDeadlineTotalDays = (stage?: string | null, apiTotalDays?: number | null): number => {
	if (apiTotalDays && apiTotalDays > 0) return apiTotalDays;
	return DEADLINE_DAYS_BY_STAGE[stage as SinisterStage] ?? DEFAULT_DEADLINE_DAYS;
};
